import React, { useState, useEffect } from 'react';
import { motion, useSpring } from "motion/react";
import cursorImage from '../mowmowmow.png';


const CatCursor = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const updateMousePosition = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', updateMousePosition);

    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
    };
  }, []);

   return (
    <>
      <div
        className="cat-cursor"
        style={{
          left: `${mousePosition.x}px`,
          top: `${mousePosition.y}px`,
          backgroundImage: `url(${cursorImage})`,
        }}
      />

      <style>{`
        .cat-cursor {
          position: fixed;
          width: 100px;
          height: 100px;
          pointer-events: none; 
          transform: translate(-50%, -50%);
          z-index: 9999;
          background-image: url(${cursorImage});
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }

        * {
          cursor: none;
        }
      `}</style>
    </>
  );
};


export default CatCursor;


